import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Brand } from "./Brand";
import { useAuth } from "../contexts/AuthContext";

export const PublicNavbar = () => {
  const { user } = useAuth();
  const nav = useNavigate();
  return (
    <motion.header
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="fixed top-0 inset-x-0 z-50 glass-strong border-b border-white/5"
      data-testid="public-navbar"
    >
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-home"><Brand /></Link>
        <nav className="hidden md:flex items-center gap-8 text-sm text-white/70">
          <a href="#flotta" className="hover:text-white transition" data-testid="nav-fleet">Flotta</a>
          <a href="#funzioni" className="hover:text-white transition" data-testid="nav-features">Funzioni</a>
          <a href="#numeri" className="hover:text-white transition" data-testid="nav-stats">Numeri</a>
          <a href="#faq" className="hover:text-white transition" data-testid="nav-faq">FAQ</a>
        </nav>
        <div className="flex items-center gap-3">
          {user ? (
            <button data-testid="nav-dashboard" onClick={() => nav("/admin")} className="btn-neon px-5 py-2 rounded-full text-xs">
              Dashboard
            </button>
          ) : (
            <>
              <Link data-testid="nav-login" to="/login" className="text-sm text-white/80 hover:text-white">Accedi</Link>
              <Link data-testid="nav-register" to="/register" className="btn-neon px-5 py-2 rounded-full text-xs">Inizia Ora</Link>
            </>
          )}
        </div>
      </div>
    </motion.header>
  );
};
